// import axios from "axios";
// import { useState, useEffect } from "react";
// import ApiUrl from "./../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";
// import { useNavigate } from "react-router-dom";

// function AddStock() {
//   const navigate = useNavigate();
//   const toast = useToast();

//   const [items, setItems] = useState([]);
//   const [typeGetting, setTypeGetting] = useState([]);
//   const [editingIndex, setEditingIndex] = useState(null);

//   const [addData, setAddData] = useState({
//     item: "",
//     quantity: "",
//     category: "",
//     weight: "",
//     date: new Date().toISOString().split("T")[0],
//     created_by: "",
//     created_date: "",
//   });

//   useEffect(() => {
//     fetchProductType();
//   }, []);

//   const fetchProductType = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setTypeGetting(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching product types:", error.message);
//       setTypeGetting([]);
//       toast.error("Error fetching product types", 3000, "topRight");
//     }
//   };

//   const handleAddItem = () => {
//     if (
//       !addData.category ||
//       !addData.item ||
//       !addData.quantity ||
//       !addData.weight
//     ) {
//       toast.error("Please fill all required fields", 3000, "topRight");
//       return;
//     }

//     // Get the selected type name for display
//     const selectedType = typeGetting.find((type) => type._id === addData.item);
//     const typeName = selectedType ? selectedType.type : addData.item;

//     const newItem = {
//       date: addData.date,
//       status: "in", // Adding status as shown in your expected structure
//       item: typeName, // Use the type name for display
//       type_id: addData.item, // Keep the ID for reference
//       quantity: addData.quantity,
//       category: addData.category,
//       weight: addData.weight,
//       created_by: "",
//       created_date: "",
//       updated_by: "",
//       updated_date: "",
//     };

//     if (editingIndex !== null) {
//       const updatedItems = [...items];
//       updatedItems[editingIndex] = newItem;
//       setItems(updatedItems);
//       setEditingIndex(null);
//     } else {
//       setItems([...items, newItem]);
//     }

//     setAddData((prev) => ({
//       ...prev,
//       item: "",
//       quantity: "",
//       weight: "",
//       category: "",
//     }));
//   };

//   const handleEditItem = (index) => {
//     const itemToEdit = items[index];
//     setAddData({
//       ...addData,
//       item: itemToEdit.type_id || itemToEdit.item,
//       quantity: itemToEdit.quantity,
//       category: itemToEdit.category,
//       weight: itemToEdit.weight,
//       date: itemToEdit.date,
//     });
//     setEditingIndex(index);
//   };

//   const handleRemoveItem = (index) => {
//     const updatedItems = items.filter((_, i) => i !== index);
//     setItems(updatedItems);
//   };

//   // Calculate totals for the overall stock
//   const calculateTotals = () => {
//     const totalQuantity = items.reduce(
//       (sum, item) => sum + parseInt(item.quantity || 0),
//       0
//     );
//     const totalWeight = items.reduce(
//       (sum, item) => sum + parseFloat(item.weight || 0),
//       0
//     );

//     return {
//       total_quantity: totalQuantity,
//       total_weight: totalWeight,
//       avaliable_quantity: totalQuantity, // Initially all items are available
//       sold_quantity: 0, // Initially no items are sold
//     };
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return;
//     }

//     try {
//       const totals = calculateTotals();

//       // Get the main category and item name for the overall stock
//       const mainCategory = items[0]?.category || "";
//       const mainItemName =
//         items.length === 1 ? items[0].item : `${mainCategory} Items`;

//       const payload = {
//         // Overall stock information
//         item: mainItemName,
//         quantity: totals.total_quantity.toString(),
//         amount: "0", // You might want to calculate this based on rates
//         category: mainCategory,
//         weight: `${totals.total_weight}g`,
//         avaliable_quantity: totals.avaliable_quantity.toString(),
//         total_quantity: totals.total_quantity.toString(),
//         sold_quantity: totals.sold_quantity.toString(),
//         created_by: "", // You can get this from user context
//         created_date: "",
//         updated_by: "",
//         updated_date: "",
//         // Stock list with individual items
//         stock_list: items.map((item) => ({
//           date: item.date,
//           status: item.status,
//           item: item.item,
//           type_id: item.type_id,
//           quantity: item.quantity,
//           category: item.category,
//           weight: item.weight,
//           created_by: "",
//           created_date: "",
//           updated_by: "",
//           updated_date: "",
//         })),
//       };

//       console.log("Submit payload:", payload);

//       const response = await axios.post(`${ApiUrl}/Api/stock.php`, payload);
//       console.log("Submit response:", response);

//       toast.success("Stock added successfully!", 3000, "topRight");
//       setItems([]);
//       navigate("/stocks");
//     } catch (error) {
//       console.error("Error submitting data:", error.message);
//       toast.error("Error submitting data", 3000, "topRight");
//     }
//   };

//   return (
//     <>
//       <div className="container-fluid">
//         <div className="card card-body">
//           <h6 className="mb-3">Add Stock Items</h6>
//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Date</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 value={addData.date}
//                 placeholder="Date"
//                 onChange={(e) =>
//                   setAddData({ ...addData, date: e.target.value })
//                 }
//                 required
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Category</label>
//               <select
//                 className="form-select"
//                 value={addData.category}
//                 onChange={(e) =>
//                   setAddData({ ...addData, category: e.target.value })
//                 }
//                 required
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//                 <option value="Jewelry">Jewelry</option>
//               </select>
//             </div>

//             <div className="col-md-3">
//               <label className="form-label">Item Name</label>
//               <select
//                 className="form-select"
//                 value={addData.item}
//                 onChange={(e) => {
//                   setAddData({ ...addData, item: e.target.value });
//                 }}
//                 required
//               >
//                 <option value="">Select Type</option>
//                 {typeGetting.map((item) => (
//                   <option key={item._id} value={item._id}>
//                     {item.type}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Quantity</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Quantity"
//                 value={addData.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   // Allow only numbers, up to 5 digits (adjust if needed)
//                   if (/^\d{0,5}$/.test(value)) {
//                     setAddData({ ...addData, quantity: value });
//                   }
//                 }}
//                 required
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight"
//                 value={addData.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   // Allow numbers with optional 1 dot and up to 3 decimal places
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     setAddData({ ...addData, weight: value });
//                   }
//                 }}
//                 required
//               />
//             </div>

//             <div className="col-md-1 d-flex align-items-end">
//               <button
//                 className={`btn btn-sm w-100 ${
//                   editingIndex === null ? "btn-success" : "btn-primary"
//                 }`}
//                 onClick={handleAddItem}
//                 type="button"
//               >
//                 <i
//                   className={`bi ${
//                     editingIndex === null ? "bi-plus" : "bi-check"
//                   }`}
//                 ></i>
//               </button>
//             </div>

//             <div className="col-md-1 d-flex align-items-end">
//               <button
//                 className="btn btn-primary w-100"
//                 onClick={handleSubmit}
//                 disabled={items.length === 0}
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="container-fluid py-3">
//         <div className="card shadow-sm">
//           <div className="card-body">
//             {items.length > 0 && (
//               <div className="row mb-3">
//                 <div className="col-md-12">
//                   <div className="alert alert-info">
//                     <strong>Summary:</strong>
//                     Total Items: {items.length} | Total Quantity:{" "}
//                     {items.reduce(
//                       (sum, item) => sum + parseInt(item.quantity || 0),
//                       0
//                     )}{" "}
//                     | Total Weight:{" "}
//                     {items.reduce(
//                       (sum, item) => sum + parseFloat(item.weight || 0),
//                       0
//                     )}
//                     g
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="card tableCard p-2">
//               <div className="table-responsive">
//                 <table className="table">
//                   <thead className="bg-light">
//                     <tr>
//                       <th>S.No</th>
//                       <th>Date</th>
//                       <th>Category</th>
//                       <th>Item</th>
//                       <th>Quantity</th>
//                       <th>Weight (g)</th>
//                       {/* <th>Status</th> */}
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {items.length > 0 ? (
//                       items.map((item, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{item.date}</td>
//                           <td>{item.category}</td>
//                           <td>{item.item_tamil ? `${item.item} / ${item.item_tamil}` : item.item}</td>
//                           <td>{item.quantity}</td>
//                           <td>{item.weight}g</td>
//                           {/* <td>
//                             <span className="badge bg-success">
//                               {item.status}
//                             </span>
//                           </td> */}
//                           <td>
//                             <button
//                               className="btn btn-sm btn-light me-1"
//                               onClick={() => handleEditItem(index)}
//                             >
//                               <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                             </button>
//                             <button
//                               className="btn btn-sm btn-light"
//                               onClick={() => handleRemoveItem(index)}
//                             >
//                               <i className="fa-solid fa-trash text-danger fs-6"></i>
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" className="text-center">
//                           No items added yet
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AddStock;

import axios from "axios";
import { useState, useEffect } from "react";
import ApiUrl from "./../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import { useNavigate } from "react-router-dom";

function AddStock() {
  const navigate = useNavigate();
  const toast = useToast();

  const [items, setItems] = useState([]);
  const [products, setProducts] = useState([]); // Changed from typeGetting
  const [filteredProducts, setFilteredProducts] = useState([]); // For category filtering
  const [editingIndex, setEditingIndex] = useState(null);
const [loading, setLoading] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
const [isTranslating, setIsTranslating] = useState(false);
const [productFormErrors, setProductFormErrors] = useState({});
const [productAddData, setProductAddData] = useState({
  item_code: "",
  item_name: "",
  item_name_english: "",
  item_name_tamil: "",
  category: "",
  type: "",
  pure_percent: "",
  status: "Active",
  image: null,
});

  const [addData, setAddData] = useState({
    item: "",
    quantity: "",
    category: "",
    weight: "",
    date: new Date().toISOString().split("T")[0],
    created_by: "",
    created_date: "",
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const translateToTamil = async (englishText) => {
  if (!englishText || englishText.trim().length < 2) return "";
  
  setIsTranslating(true);
  
  const apis = [
    async () => {
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(`https://api.mymemory.translated.net/get?q=${encoded}&langpair=en|ta`);
      const data = await res.json();
      const translated = data?.responseData?.translatedText;
      if (translated && translated.toLowerCase() !== englishText.toLowerCase()) {
        return translated;
      }
      return null;
    },
    async () => {
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(`https://lingva.ml/api/v1/en/ta/${encoded}`);
      if (res.ok) {
        const data = await res.json();
        if (data.translation && data.translation !== englishText) {
          return data.translation;
        }
      }
      return null;
    },
    async () => {
      const res = await fetch('https://libretranslate.com/translate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          q: englishText.trim(),
          source: 'en',
          target: 'ta',
          format: 'text'
        })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.translatedText) {
          return data.translatedText;
        }
      }
      return null;
    }
  ];
  
  for (const api of apis) {
    try {
      const result = await api();
      if (result) {
        setIsTranslating(false);
        return result;
      }
    } catch (error) {
      console.warn("Translation API failed:", error);
      continue;
    }
  }
  
  setIsTranslating(false);
  return "";
};


const fetchProductItemCode = async () => {
  try {
    const response = await axios.get(`${ApiUrl}/Api/product.php/generate-item-code`);
    setProductAddData(prev => ({
      ...prev,
      item_code: response.data?.item_code || "",
    }));
  } catch (error) {
    console.error("Error fetching product item code:", error.message);
    toast.error("Failed to generate product code", 3000, "topRight");
  }
};

const openProductModal = () => {
  fetchProductItemCode();
  setProductAddData({
    item_code: "",
    item_name: "",
    item_name_english: "",
    item_name_tamil: "",
    category: addData.category || "", // Pre-fill category if selected
    type: "",
    pure_percent: "",
    status: "Active",
    image: null,
  });
  setProductFormErrors({});
  setShowProductModal(true);
};

const closeProductModal = () => {
  setShowProductModal(false);
  setProductAddData({
    item_code: "",
    item_name: "",
    item_name_english: "",
    item_name_tamil: "",
    category: "",
    type: "",
    pure_percent: "",
    status: "Active",
    image: null,
  });
  setProductFormErrors({});
};

const handleProductSubmit = async (e) => {
  e.preventDefault();

  const errors = {};
  if (!productAddData.item_name_english) errors.item_name = "Item name is required";
  if (!productAddData.category) errors.category = "Category is required";
  if (!productAddData.pure_percent) errors.pure_percent = "Purity percentage is required";
  if (!productAddData.status) errors.status = "Status is required";

  if (Object.keys(errors).length > 0) {
    setProductFormErrors(errors);
    return;
  }

  try {
    setLoading(true);
    const formData = new FormData();
    
    let finalTamilName = productAddData.item_name_tamil;
    if (!finalTamilName && productAddData.item_name_english) {
      finalTamilName = await translateToTamil(productAddData.item_name_english);
    }

    formData.append("item_code", productAddData.item_code || "");
    formData.append("item_name", productAddData.item_name_english || "");
    formData.append("item_name_english", productAddData.item_name_english || "");
    formData.append("item_name_tamil", finalTamilName || "");
    formData.append("category", productAddData.category || "");
    formData.append("type", productAddData.type || "");
    formData.append("pure_percent", productAddData.pure_percent || "");
    formData.append("status", productAddData.status || "");
    formData.append("created_by", "stock");

    if (productAddData.image) {
      formData.append("image", productAddData.image);
    }

    const response = await axios.post(`${ApiUrl}/Api/product.php`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.data?.status === true || response.status === 200 || response.status === 201) {
      toast.success("Product added successfully!", 3000, "topRight");
      closeProductModal();
      await fetchProducts(); // Refresh product list
      
      // Auto-select the newly added product if category matches
      if (response.data?.data?.id) {
        setAddData(prev => ({ ...prev, item: response.data.data.id }));
      }
    } else {
      throw new Error(response.data?.message || "Failed to add product");
    }
  } catch (error) {
    console.error("Error adding product:", error);
    toast.error(error.response?.data?.message || "Failed to add product", 3000, "topRight");
  } finally {
    setLoading(false);
  }
};

  // Filter products based on selected category
  useEffect(() => {
    if (addData.category) {
      const filtered = products.filter(product => 
        product.category === addData.category
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [addData.category, products]);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/product.php`);
      setProducts(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching products:", error.message);
      setProducts([]);
      toast.error("Error fetching products", 3000, "topRight");
    }
  };

  const handleAddItem = () => {
    if (
      !addData.category ||
      !addData.item ||
      !addData.quantity ||
      !addData.weight
    ) {
      toast.error("Please fill all required fields", 3000, "topRight");
      return;
    }

    // Get the selected product details
    const selectedProduct = products.find((product) => String(product.id) === String(addData.item));
    const productName = selectedProduct
      ? (selectedProduct.item_name_english || selectedProduct.item_name)
      : addData.item;
    const productTamil = selectedProduct?.item_name_tamil || "";

    const newItem = {
      date: addData.date,
      status: "In Stock",
      item: productName,
      item_tamil: productTamil,
      product_id: addData.item,
      quantity: parseInt(addData.quantity),
      category: addData.category,
      weight: parseFloat(addData.weight).toFixed(2),
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    };

    if (editingIndex !== null) {
      const updatedItems = [...items];
      updatedItems[editingIndex] = newItem;
      setItems(updatedItems);
      setEditingIndex(null);
    } else {
      setItems([...items, newItem]);
    }

    setAddData((prev) => ({
      ...prev,
      item: "",
      quantity: "",
      weight: "",
      category: "",
    }));
  };

  const handleEditItem = (index) => {
    const itemToEdit = items[index];
    setAddData({
      ...addData,
      item: itemToEdit.product_id || itemToEdit.item,
      quantity: itemToEdit.quantity.toString(),
      category: itemToEdit.category,
      weight: itemToEdit.weight,
      date: itemToEdit.date,
    });
    setEditingIndex(index);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
    setEditingIndex(null);
  };

  // Calculate totals for the overall stock
  const calculateTotals = () => {
    const totalQuantity = items.reduce(
      (sum, item) => sum + parseInt(item.quantity || 0),
      0
    );
    const totalWeight = items.reduce(
      (sum, item) => sum + parseFloat(item.weight || 0),
      0
    );

    return {
      total_quantity: totalQuantity,
      total_weight: totalWeight.toFixed(2),
      avaliable_quantity: totalQuantity,
      sold_quantity: 0,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (items.length === 0) {
      toast.error("Please add at least one item", 3000, "topRight");
      return;
    }

    try {
      const totals = calculateTotals();

      // Aggregate items by category and item for the overall stock
      const groupedItems = items.reduce((acc, item) => {
        const key = `${item.category}-${item.item}`;
        if (!acc[key]) {
          acc[key] = {
            item: item.item,
            category: item.category,
            quantity: 0,
            weight: 0,
            total_quantity: 0,
            avaliable_quantity: 0,
            sold_quantity: 0,
          };
        }
        acc[key].quantity += parseInt(item.quantity);
        acc[key].weight += parseFloat(item.weight);
        acc[key].total_quantity += parseInt(item.quantity);
        acc[key].avaliable_quantity += parseInt(item.quantity);
        return acc;
      }, {});

      const mainCategory = items[0]?.category || "";
      const mainItemName =
        Object.values(groupedItems).length === 1
          ? items[0].item
          : `${mainCategory} Items`;

      const payload = {
        item: mainItemName,
        quantity: totals.total_quantity.toString(),
        amount: "0",
        category: mainCategory,
        weight: `${totals.total_weight}g`,
        avaliable_quantity: totals.avaliable_quantity.toString(),
        total_quantity: totals.total_quantity.toString(),
        sold_quantity: totals.sold_quantity.toString(),
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
        stock_list: items.map((item) => ({
          date: item.date,
          status: item.status,
          item: item.item,
          item_tamil: item.item_tamil,
          product_id: item.product_id,
          quantity: item.quantity.toString(),
          category: item.category,
          weight: `${item.weight}g`,
          created_by: "",
          created_date: "",
          updated_by: "",
          updated_date: "",
        })),
      };

      console.log("Submit payload:", payload);

      const response = await axios.post(`${ApiUrl}/Api/stock.php`, payload);
      console.log("Submit response:", response);

      toast.success("Stock added successfully!", 3000, "topRight");
      setItems([]);
      navigate("/stocks");
    } catch (error) {
      console.error("Error submitting data:", error.message);
      toast.error("Error submitting data", 3000, "topRight");
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card card-body">
          <h6 className="mb-3">Add Stock Items</h6>
          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Date</label>
              <input
                type="date"
                className="form-control"
                value={addData.date}
                placeholder="Date"
                onChange={(e) =>
                  setAddData({ ...addData, date: e.target.value })
                }
                required
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Category</label>
              <select
                className="form-select"
                value={addData.category}
                onChange={(e) =>
                  setAddData({ ...addData, category: e.target.value })
                }
                required
              >
                <option value="">Select Category</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
              </select>
            </div>

            <div className="col-md-3">
  <label className="form-label">Item Name</label>
  <div className="d-flex align-items-center gap-1">
    <select
      className="form-select"
      value={addData.item}
      onChange={(e) => {
        setAddData({ ...addData, item: e.target.value });
      }}
      disabled={!addData.category}
      required
      style={{ width: "calc(100% - 40px)" }}
    >
      <option value="">Select Item</option>
      {filteredProducts.map((product) => (
        <option key={product.id} value={product.id}>
          {product.item_name_tamil
            ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
            : (product.item_name_english || product.item_name)}
        </option>
      ))}
    </select>
    <button
      type="button"
      className="btn btn-outline-primary btn-sm"
      onClick={openProductModal}
      title="Add New Product"
      disabled={!addData.category}
      style={{ height: "32px", width: "32px" }}
    >
      <i className="bi bi-plus"></i>
    </button>
  </div>
  {!addData.category && (
    <small className="text-muted text-danger">Please select category first</small>
  )}
</div>

            <div className="col-md-1">
              <label className="form-label">Quantity</label>
              <input
                type="text"
                inputMode="numeric"
                className="form-control"
                placeholder="Quantity"
                value={addData.quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,5}$/.test(value)) {
                    setAddData({ ...addData, quantity: value });
                  }
                }}
                required
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Weight (g)</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                placeholder="Weight"
                value={addData.weight}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,3}$/.test(value)) {
                    setAddData({ ...addData, weight: value });
                  }
                }}
                required
              />
            </div>

            <div className="col-md-1 d-flex align-items-end">
              <button
                className={`btn btn-sm w-100 ${
                  editingIndex === null ? "btn-success" : "btn-primary"
                }`}
                onClick={handleAddItem}
                type="button"
              >
                <i
                  className={`bi ${
                    editingIndex === null ? "bi-plus" : "bi-check"
                  }`}
                ></i>
              </button>
            </div>

            <div className="col-md-1 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                onClick={handleSubmit}
                disabled={items.length === 0}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid py-3">
        <div className="card shadow-sm">
          <div className="card-body">
            {items.length > 0 && (
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="alert alert-info">
                    <strong>Summary:</strong>
                    Total Items: {items.length} | Total Quantity:{" "}
                    {items.reduce(
                      (sum, item) => sum + parseInt(item.quantity || 0),
                      0
                    )}{" "}
                    | Total Weight:{" "}
                    {items.reduce(
                      (sum, item) => sum + parseFloat(item.weight || 0),
                      0
                    ).toFixed(2)}
                    g
                  </div>
                </div>
              </div>
            )}

            <div className="card tableCard p-2">
              <div className="table-responsive">
                <table className="table">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Item</th>
                      <th>Quantity</th>
                      <th>Weight (g)</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.length > 0 ? (
                      items.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.date}</td>
                          <td>{item.category}</td>
                          <td>{item.item_tamil ? `${item.item} / ${item.item_tamil}` : item.item}</td>
                          <td>{item.quantity}</td>
                          <td>{item.weight}g</td>
                          <td>
                            <button
                              className="btn btn-sm btn-light me-1"
                              onClick={() => handleEditItem(index)}
                            >
                              <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() => handleRemoveItem(index)}
                            >
                              <i className="fa-solid fa-trash text-danger fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No items added yet
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add Product Modal */}
<div
  className={`modal fade ${showProductModal ? "show" : ""}`}
  style={{
    display: showProductModal ? "block" : "none",
    backgroundColor: "rgba(0,0,0,0.5)",
  }}
  tabIndex="-1"
  aria-labelledby="addProductModalLabel"
  aria-hidden={!showProductModal}
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h6 className="modal-title text-primary" id="addProductModalLabel">
          Add Product
        </h6>
        <button
          type="button"
          className="btn-close"
          style={{ fontSize: "10px" }}
          onClick={closeProductModal}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleProductSubmit}>
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="item_code" className="form-label">
                  Item Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="item_code"
                  value={productAddData.item_code}
                  disabled
                  readOnly
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="product_category" className="form-label">
                  Category <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${productFormErrors.category ? "is-invalid" : ""}`}
                  id="product_category"
                  value={productAddData.category}
                  onChange={(e) =>
                    setProductAddData({ ...productAddData, category: e.target.value })
                  }
                >
                  <option value="">Select Category</option>
                  <option value="Gold">Gold</option>
                  <option value="Silver">Silver</option>
                </select>
                {productFormErrors.category && (
                  <div className="invalid-feedback">{productFormErrors.category}</div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="mb-3">
                <label htmlFor="item_name_english" className="form-label">
                  Item Name <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className={`form-control ${productFormErrors.item_name ? "is-invalid" : ""}`}
                    id="item_name_english"
                    placeholder="Enter item name in English (Tamil will auto-translate)"
                    value={productAddData.item_name_english}
                    onChange={(e) =>
                      setProductAddData({
                        ...productAddData,
                        item_name_english: e.target.value,
                        item_name: e.target.value,
                        item_name_tamil: "",
                      })
                    }
                    onBlur={async (e) => {
                      const val = e.target.value.trim();
                      if (val && !productAddData.item_name_tamil) {
                        const tamil = await translateToTamil(val);
                        if (tamil) {
                          setProductAddData(prev => ({ ...prev, item_name_tamil: tamil }));
                          toast.info(`Tamil translation: ${tamil}`, 2000, "topRight");
                        }
                      }
                    }}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    title="Translate to Tamil"
                    disabled={isTranslating || !productAddData.item_name_english}
                    style={{ height: "38px" }}
                    onClick={async () => {
                      const tamil = await translateToTamil(productAddData.item_name_english);
                      if (tamil) {
                        setProductAddData(prev => ({ ...prev, item_name_tamil: tamil }));
                        toast.success("Translated successfully!", 1500, "topRight");
                      } else {
                        toast.error("Translation failed. Please try again.", 2000, "topRight");
                      }
                    }}
                  >
                    {isTranslating ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      "🌐 Translate"
                    )}
                  </button>
                </div>
                {productAddData.item_name_tamil && (
                  <small className="text-muted mt-1 d-block">
                    <strong>Tamil:</strong> {productAddData.item_name_tamil}
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 ms-2 text-muted"
                      onClick={() => setProductAddData(prev => ({ ...prev, item_name_tamil: "" }))}
                    >
                      ✕ clear
                    </button>
                  </small>
                )}
                {productFormErrors.item_name && (
                  <div className="invalid-feedback">{productFormErrors.item_name}</div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="pure_percent" className="form-label">
                  Purity (%) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  max="100"
                  className={`form-control ${productFormErrors.pure_percent ? "is-invalid" : ""}`}
                  id="pure_percent"
                  placeholder="e.g. 99.9"
                  value={productAddData.pure_percent}
                  onChange={(e) =>
                    setProductAddData({ ...productAddData, pure_percent: e.target.value })
                  }
                />
                {productFormErrors.pure_percent && (
                  <div className="invalid-feedback">{productFormErrors.pure_percent}</div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="product_status" className="form-label">
                  Status <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${productFormErrors.status ? "is-invalid" : ""}`}
                  id="product_status"
                  value={productAddData.status}
                  onChange={(e) =>
                    setProductAddData({ ...productAddData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
                {productFormErrors.status && (
                  <div className="invalid-feedback">{productFormErrors.status}</div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="mb-3">
              <label htmlFor="product_image" className="form-label">
                Image Upload
              </label>
              <input
                type="file"
                className="form-control"
                id="product_image"
                onChange={(e) =>
                  setProductAddData({ ...productAddData, image: e.target.files[0] })
                }
                accept="image/*"
              />
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              type="submit"
              className="btn btn-primary btn-sm px-4"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Product"}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
{showProductModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default AddStock;